import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default function(){
	/* Variables */
	//const trigger = document.querySelector( '[data-js="grid-trigger]' )
	const gridImages = document.querySelector( '.grid-images' )
	const dataContent = document.querySelectorAll( '[data-content]' )

	if ( window.innerWidth > 699 ) {
		/* Preparation */
	
		// Images same height as first block (keeping aspect ratio) and only first image visible
		const firstContentBlock = document.querySelector( '[data-content="1"]' )
		const imagesBlocks = document.querySelectorAll( '[data-image]' )
	
		if ( imagesBlocks.length > 0 ) {
			imagesBlocks.forEach( ( image, index ) => {
				if ( index !== 0 ) {
					image.style.opacity = 0
				}
				image.querySelector( 'div:nth-child(1)' ).style.aspectRatio = firstContentBlock.clientWidth + '/' + firstContentBlock.clientHeight
			});
		}
	
		// Calculate the end point (gsap animation) for the pin image
		// Default would be if next element is NOT a social instagram block
		const nextSocialBlock = document.querySelector( '.block--vertical-carousel + .block--social-instagram' )
		let endTriggerPoint = [].slice.call(dataContent).pop() // last content block
		let endPointAnimation = `top top`
	
		if ( nextSocialBlock ) {
			// We need a different end trigger
			function calculateVerticalSpaceFromTops(element1, element2) {
				const rect1 = element1.getBoundingClientRect();
				const rect2 = element2.getBoundingClientRect();
				const verticalSpace = rect2.top - rect1.top;
			
				return verticalSpace;
			}
			
			// Calculate space between elements.
			const element1 = nextSocialBlock.querySelector('.instagram-col-1')
			const element2 = nextSocialBlock.querySelector('.instagram-col-2')
			const spaceBetweenElements = calculateVerticalSpaceFromTops(element1, element2);
			const spaceBetweenImageAndBottomScreen = window.innerHeight - document.querySelector( '[data-image]' ).clientHeight
	
			let extraSpace = 135
			if ( window.innerWidth < 828 ){
				extraSpace = 105
			}
	
			endPointAnimation = `top bottom-=${spaceBetweenElements + spaceBetweenImageAndBottomScreen - extraSpace}px`
			endTriggerPoint = nextSocialBlock.querySelector('.instagram-col-1')
		}
	
	
		/* Start animation */
	
		// Pin image
		if ( gridImages ) {
			ScrollTrigger.create({
				trigger: gridImages,
				endTrigger: endTriggerPoint,
				pin: gridImages,
				pinSpacing: false,
				anticipatePin: 1,
				start: "top top+=75",
				end: endPointAnimation,
				//markers: true,
			});
		}
	
		// Spy Scroll like animation
		if ( dataContent.length > 0 ) {
			dataContent.forEach(content => {
				let contentNumber = content.dataset.content
				let relatedImage  = document.querySelector( '[data-image="' + contentNumber + '"]' )
				let allImagesButRelated = document.querySelectorAll( '[data-image]:not( [data-image="' + contentNumber + '"] )' )
	
				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: content,
						start: 'top top+=50%',
						toggleActions:"play complete play reset",
						//markers: true
					}
				});
	
				tl
					//.to( allImagesButRelated, { opacity: 0 } )
					.to( relatedImage, { opacity: 1 } )
			});
		}
	}
}